import React from "react";
import { Helmet } from "react-helmet";
import Header from "../../components/ui/Header";
import HeroSection from "./components/HeroSection";
import MissionVisionSection from "./components/MissionVisionSection";
import LeadershipSection from "./components/LeadershipSection";
import VirtualTourSection from "./components/VirtualTourSection";
import AccreditationSection from "./components/AccreditationSection";

const About = () => {
  return (
    <>
      <Helmet>
        <title>
          KARUMO TECHNICAL TRAINING INSTITUTE.
        </title>
        <meta
          name="description"
          content="Learn about KTTI's mission, vision, leadership team, and 10+ years of excellence in technical education. Discover our accreditations, campus facilities, and alumni success stories."
        />
        <meta
          name="keywords"
          content="KTTI about, technical education, mission vision, leadership team, best technical, campus tour, accreditation, alumni success"
        />
        <meta
          property="og:title"
          content="About KTTI - Excellence in Technical Education"
        />
        <meta
          property="og:description"
          content="Discover KTTI's journey of 10+ years in technical education excellence, our leadership team, modern facilities, and successful alumni network."
        />
        <meta property="og:type" content="website" />
        <link rel="canonical" href="/about" />
      </Helmet>
      <div className="min-h-screen bg-background">
        <Header />

        <main className="pt-16">
          <HeroSection />
          <MissionVisionSection />
          <LeadershipSection />
          <VirtualTourSection />
          <AccreditationSection />
        </main>

        {/* Footer */}
     <footer className="text-black py-12 bg-blue-100"  >
        <div className="container mx-auto px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            {/* About */}
            <div>
              <h3 className="text-lg font-bold mb-4">
                KARUMO TECHNICAL TRAINING INSTITUTE
              </h3>
              <p className="text-gray-800 text-lg leading-relaxed">
                Transforming careers through practical technical education.
                Building industry-ready professionals for over 10 years.
              </p>
            </div>

            {/* Quick Links */}
            <div>
              <h4 className="font-semibold mb-4">Quick Links</h4>
              <ul className="space-y-2 text-sm">
                <li>
                  <a
                    href="/about"
                    className="text-black hover:text-blue-900 transition-colors"
                  >
                    About Us
                  </a>
                </li>
                <li>
                  <a
                    href="/courses"
                    className="text-black hover:text-blue-900 transition-colors"
                  >
                    Courses
                  </a>
                </li>
                <li>
                  <a
                    href="/departments"
                    className="text-black hover:text-blue-900 transition-colors"
                  >
                    Departments
                  </a>
                </li>
                <li>
                  <a
                    href="/resources"
                    className="text-black hover:text-blue-900 transition-colors"
                  >
                    Resources
                  </a>
                </li>
              </ul>
            </div>

            {/* Contact Info */}
            <div>
              <h4 className="font-semibold mb-4">Contact Info</h4>
              <ul className="space-y-2 text-lg text-black">
                <li>📍 KARUMO TECHNICAL TRAINING INSTITUTE</li>
                <li>P.O BOX 276-60602 KIANJAI, MERU</li>
                <li>📞 +254(0)705636443</li>
                <li>✉️ info@karumotti.ac.ke</li>
                <li>🕒 Mon-Fri: 8AM-5PM</li>
              </ul>
            </div>

            {/* Follow Us */}
            <div>
              <h4 className="font-semibold mb-4">Follow Us</h4>
              <div className="flex space-x-4">
                <a
                  href="#"
                  className="w-8 h-8 bg-yellow-300 rounded-full flex items-center justify-center hover:bg-primary/80 transition-colors"
                >
                  <span className="text-lg">f</span>
                </a>
                <a
                  href="#"
                  className="w-8 h-8 bg-yellow-300 rounded-full flex items-center justify-center hover:bg-primary/80 transition-colors"
                >
                  <span className="text-lg">x</span>
                </a>
                <a
                  href="#"
                  className="w-8 h-8 bg-yellow-300 rounded-full flex items-center justify-center hover:bg-primary/80 transition-colors"
                >
                  <span className="text-lg">y</span>
                </a>
              </div>
            </div>
          </div>

          <div className="border-t border-gray-700 mt-8 pt-8 text-center">
            <p className="text-gray-900 text-sm">
              © {new Date()?.getFullYear()} KTTI. All rights reserved. |
              <a href="#" className="hover:text-white ml-1">
                Privacy Policy
              </a>{" "}
              |
              <a href="#" className="hover:text-white ml-1">
                Terms of Service
              </a>
            </p>
          </div>
        </div>
      </footer>
      </div>
    </>
  );
};

export default About;
